var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "index-form-item",
    {
      attrs: {
        labelText: _vm.labelName,
        labelWidth: _vm.labelWidth,
        labelPosition: _vm.labelPosition,
        textAlign: _vm.labelTextPosition,
        formType: _vm.formType,
        paddingLeft: _vm.paddingLeft
      }
    },
    [
      _c(
        "div",
        { staticClass: "form-item_input" },
        [
          _c(
            "el-upload",
            { attrs: { action: _vm.uploadHost, limit: _vm.uploadLimit } },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v("\n        点击上传\n      ")
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a90ec25", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a90ec25","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form_item/FormItemUploadFile.vue
// module id = null
// module chunks = 